import ApiBase from '../api-base'
import {ACTIVE_BASE_REST} from '../constants'
export default class MessageInternal extends ApiBase {
    constructor (store) {
        const path = ACTIVE_BASE_REST + '/message/internal'
        super(store, path)
    }
}